import { Component, inject, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
    DxButtonModule,
    DxDateBoxModule,
    DxFormModule,
    DxLoadPanelModule,
    DxRadioGroupModule,
    DxScrollViewModule,
    DxSelectBoxModule,
    DxTextAreaModule,
    DxTextBoxModule,
    DxToolbarModule,
    DxValidationGroupModule,
    DxValidatorModule,
} from 'devextreme-angular';
import {
    IncidentReportDto,
    IncidentCategory,
    InjuryType,
    IncidentType,
    IncidentLocation,
} from '@services';
import EnumUtils from '../../../../../../shared/enum-utils';
import { DxCheckBoxModule } from 'devextreme-angular/ui/check-box';
import { IncidentCategoryPipe } from '../../../../../../pipes/incident-category.pipe';
import { IncidentTypePipe } from '../../../../../../pipes/incident-type.pipe';
import { IncidentLocationPipe } from '../../../../../../pipes/incident-location.pipe';
import { InjuryTypePipe } from '../../../../../../pipes/injury-type.pipe';

@Component({
    selector: 'app-classification-section',
    imports: [
        CommonModule,
        DxToolbarModule,
        DxButtonModule,
        DxLoadPanelModule,
        DxValidationGroupModule,
        DxTextBoxModule,
        DxValidatorModule,
        DxSelectBoxModule,
        DxDateBoxModule,
        DxScrollViewModule,
        DxFormModule,
        DxRadioGroupModule,
        DxTextAreaModule,
        DxCheckBoxModule,
    ],
    providers: [
        IncidentCategoryPipe,
        IncidentTypePipe,
        IncidentLocationPipe,
        InjuryTypePipe,
    ],
    templateUrl: './classification-section.component.html',
})
export class ClassificationSectionComponent {
    @Input() incidentReport: IncidentReportDto;
    @Input() isReadOnly: boolean = false;
    @Input() yesOrNoOptions: any;
    @Input() validateYesNo: (args: any) => boolean = () => true;

    private incidentCategoryPipe = inject(IncidentCategoryPipe);
    private incidentTypePipe = inject(IncidentTypePipe);
    private incidentLocationPipe = inject(IncidentLocationPipe);
    private injuryTypePipe = inject(InjuryTypePipe);

    protected incidentCategoryOptions = EnumUtils.getEnumOptions(
        IncidentCategory,
        (v) => this.incidentCategoryPipe.transform(v),
    );
    protected incidentTypeOptions = EnumUtils.getEnumOptions(
        IncidentType,
        (v) => this.incidentTypePipe.transform(v),
    );
    protected incidentLocationOptions = EnumUtils.getEnumOptions(
        IncidentLocation,
        (v) => this.incidentLocationPipe.transform(v),
    );
    protected injuryTypeOptions = EnumUtils.getEnumOptions(InjuryType, (v) =>
        this.injuryTypePipe.transform(v),
    );
}
